module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = VIdT
// module chunks = 0